import { Breed, Bull } from 'types';
import segmentFromBullOrBreed from './segmentFromBullOrBreed';

const segmentIconFromBullOrBreed = (target: Bull | Breed): string =>
  `/icons/${segmentFromBullOrBreed(target).includes('l') ? 'milk' : 'meat'}.svg`;

export default segmentIconFromBullOrBreed;